import axios from './authService';
import { API_ENDPOINTS } from '../config/apiConfig';
import { getRegressionTestByIdAsync } from '../redux/regressionTestIds/regressionCrudSlice';

export async function analyzeBugWithRegression(runId) {
  const regressionTestId = localStorage.getItem('regressionTestId');
  let regressionData = null;

  if (regressionTestId) {
    const regressionRes = await getRegressionTestByIdAsync(regressionTestId);

    if (regressionRes.success && regressionRes.data?.length) {
      regressionData = regressionRes.data[0];
    }
  }

  const payload = {
    runId,
    regression_test_id: regressionData?.regression_test_id,
    configuration: regressionData?.configuration,
    build: regressionData?.build,
    version: regressionData?.version,
  };

  const res = await axios.post(API_ENDPOINTS.ANALYZE_BUG, payload);
  return res.data;
}
